import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import contractApi from '../../APIs/contract';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Tag,
  Typography,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import { CONTRACT_DETAILS_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { humanReadableDate, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { ContractContainerStyled } from './style';

type ParamsType = {
  page: number;
  limit: number;
};
const Contract = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();

  const contracts = useSelector((state: RootState) => state.contracts.data);

  const pagination = useSelector(
    (state: RootState) => state.contracts.pagination
  );
  const handleContracts = async (myParams: MyParamsType) => {
    try {
      requestAPI(
        contractApi.getAllContract({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
  const debouncedFunction = useCallback(
    debounce((myParams) => handleContracts(myParams), 500),
    []
  );

  useEffect(() => {
    handleContracts(pagination);
  }, []);

  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'contractBy', label: 'Contract By' },
      { key: 'title', label: 'Job Title' },

      { key: 'status', label: 'Status' },

      {
        key: 'actions',
        label: 'Action',
      },
    ],
    body: Array.isArray(contracts)
      ? contracts?.map((contract) => {
          return {
            id: contract?.id,
            contractBy: contract?.createdBy?.emailAddress,
            date: humanReadableDate(contract?.createdAt),
            title: contract?.job?.jobTitle,
            status: (
              <Tag
                type={
                  contract?.contractStatus === 'ACCEPT'
                    ? 'success'
                    : contract?.contractStatus === 'REJECT'
                      ? 'danger'
                      : 'warning'
                }
              >
                {contract?.contractStatus}
              </Tag>
            ),
            actions: (
              <Button
                variant="secondary"
                onClick={() =>
                  navigate(
                    CONTRACT_DETAILS_ROUTE.replace(':contractId', contract._id)
                  )
                }
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
            ),
          };
        })
      : [],
  };

  const handlePagination = (updatedParams: ParamsType) => {
    handleContracts(updatedParams);
    dispatch(
      Store.Actions.update('contracts.pagination', {
        ...pagination,
        ...updatedParams,
      })
    );
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  return (
    <ContractContainerStyled>
      <PageHeader
        pageTitle={<Typography variant="title">Contracts</Typography>}
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />

      <div className="table-container">
        <Table tableData={tableData} maxWidthForCardView="800px" />
      </div>

      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 1}
      />
    </ContractContainerStyled>
  );
};

export default Contract;
